import { graphql } from 'react-relay';

import EcommerceCategory from './containers/EcommerceCategory';
import ProductsTable from './containers/ProductsTable';
import ProductIssuesTable from './containers/ProductIssuesTable';

import { createRenderFunction } from '../../utils/redirects';

export default ({
  path: 'ecommerce',
  Component: EcommerceCategory,
  query: graphql`
    query ecommerce_EcommerceCategory_Query($host: String!) {
      project(host: $host) {
        ...EcommerceCategory_project
      }
    }
  `,
  render: createRenderFunction({ redirectTo: '/products' }),
  prepareVariables: params => ({ ...params, host: params.url }),
  children: [
    {
      Component: ProductsTable,
      path: 'products',
      query: graphql`
        query ecommerce_ProductsTable_Query($host: String!) {
          project(host: $host) {
            ...ProductsTable_project
          }
        }
      `
    },
    {
      Component: ProductIssuesTable,
      path: 'product-issues',
      query: graphql`
        query ecommerce_ProductIssuesTable_Query($host: String!) {
          project(host: $host) {
            ...ProductIssuesTable_project
          }
        }
      `
    }
  ]
});
